export default {
  apiBaseUrl: 'https://ireland-prod-account-api.august.com',
  enableTranslations: false,
};
